import axios from "axios";
import { VENDORID } from "../constants";
import { CONFIG } from "../config";

//get setting
 export async function getBasketFromApi(slipRef) {
    var request = await axios.post(CONFIG.URL, {
      serviceId: '5356',
      vendorId: VENDORID,
      token: sessionStorage.getItem('token'),
      orderRef: slipRef,
    });
    return request.data;
  }